import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import { Link } from 'react-router-dom';

import './style.css';

class Article extends Component {
  render() {
    const { id, image, title } = this.props;
    const link = `/article/${id}`;

    return (
      <Link className="article" to={link}>
          <img src={image} alt={title} />
          <div className="article-item-title">
              <div>
                  <Truncate
                      lines={2}
                      ellipsis='...'>
                          {title}
                  </Truncate>
              </div>
          </div>
      </Link>
    )
  }
}

Article.propTypes = {
  image: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string
};

export default Article;



// WEBPACK FOOTER //
// ./src/components/common/article/index.jsx